import RequestService from "@/services/request.service";
import { AppError } from "@/services/error.service";

const InvitesService = {
  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Invites/Invite%20Details
  get: async function (invite_link_uuid) {
    try {
      const path = `/api/v1/public/invite/${invite_link_uuid}/`;
      const headers = {
        "Content-Type": "application/json",
      };

      return await RequestService.get(path, null, headers);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Invites/Submit%20Invite%20Guest
  submitGuests: async function (invite_link_uuid, data) {
    try {
      const path = `/api/v1/public/invite/${invite_link_uuid}/submit-guests/`;
      const headers = {
        "Content-Type": "application/json",
      };

      return await RequestService.post(path, data, null, headers);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // Generates a PDF file with ticket details
  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Invites/Generate%20Tickets%20PDF
  generateTicketsPDF: async function (invite_link_uuid) {
    try {
      const path = `/api/v1/public/invite/${invite_link_uuid}/tickets-pdf/`;
      return await RequestService.getBlob(path);
    } catch (error) {
      throw new AppError(error);
    }
  },
};

export default InvitesService;
